module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-right-circle-fill-86b33a5d.svg";